var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._m(0), _c('div', {
    staticClass: "page__button"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline mt-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeLiff
    }
  }, [_vm._v("關閉")])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v("模組未啟用")])]);
}]

export { render, staticRenderFns }